import {APIService} from "../../common/APIService";
import {EmployeeLocation} from "../../dto/EmployeeLocation";

export class EmployeeLocationService extends APIService {
  public async browse() {
    const json = await this.getJson<{ data: object[] }>(`location?date=${Math.floor((new Date()).getTime()/1000)}`)
    return json.data.map(EmployeeLocation.fromJson)
  }
}